import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=c684250e&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c684250e')) {
      api.createRecord('c684250e', component.options)
    } else {
      api.reload('c684250e', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=c684250e&", function () {
      api.rerender('c684250e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mtGsiPAh5fBw/JS/cancellationPolicy.vue"
export default component.exports